//@flow
import enUS from "./en-US"
import esES from "./es-ES"
import { LOCALE_EN, LOCALE_ES } from "../constants"

export default {
  [LOCALE_EN]: enUS,
  [LOCALE_ES]: esES
}



// WEBPACK FOOTER //
// ./src/Intl/messages/index.js